// Bir sözleşmeye ait yenileme kayıtları (geçmiş için).
export const GET_CONTRACT_RENEWALS_BY_CONTRACT_QUERY = `
  query GetContractRenewalsByContract($contractId: Int!) {
    contract_renewals(
      where: { contract_id: { _eq: $contractId } }
      order_by: { renewal_end_date: desc }
    ) {
      id
      contract_id
      renewal_start_date
      renewal_end_date
      description
      new_monthly_amount
      created_by_user_id
      created_at
      created_by { id first_name last_name }
    }
  }
`;
